import { motion } from 'framer-motion';
import '../../styles/components/sidebar/sidebarProfileTheme2.scss';
import CustomSVGs from '../../ui/customSVGs/CustomSVGs';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import {
  creditCardSVG,
  logoutSVG,
  questionSVG,
  settingsPlusSVG,
} from '../../lib/allCustomSVGs';
import { tokenRevokeAtLogOutUser } from '../../lib/api/logout-user';
import {
  APP_ENV,
  INTERCOM_ENABLED_ENVS,
} from '../../lib/constants/central-api';
import { useNavigate } from 'react-router-dom';
import { setIsPaymentPopupOpen } from '../../store/reducers/uiSlice';
import localStorageHardReset from '../../lib/helper-functions/localStorageHardReset';

type Props = {
  isProfileLinkHidden?: boolean;
  isSettingsLinkHidden?: boolean;
};

const SidebarProfileTheme2 = ({
  isProfileLinkHidden,
  isSettingsLinkHidden,
}: Props) => {
  const { t } = useTranslation();
  const appTheme = useSelector((state: RootState) => state.UI.theme.dark);
  const taraSubscriptionDetails = useSelector(
    (state: RootState) => state.user?.shop?.taraSubscriptionDetails
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logoutHandler = () => {
    tokenRevokeAtLogOutUser();
    if (INTERCOM_ENABLED_ENVS.includes(APP_ENV)) {
      // @ts-ignore:next-line
      window.Intercom && window.Intercom('shutdown'); //shutdown intercom
    }

    localStorageHardReset();

    navigate(
      window?.location?.pathname === '/register' ? '/register' : '/login'
    );
  };

  return (
    <motion.ul
      className='sidebarProfileTheme2'
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
    >
      {!isProfileLinkHidden &&
      (!taraSubscriptionDetails ||
        taraSubscriptionDetails?.currentSubscriptionStatus === 'none') ? (
        <li
          onClick={() => {
            dispatch(setIsPaymentPopupOpen(true));
          }}
        >
          <CustomSVGs svg={creditCardSVG} />
          <span>{t('PricingPlans')}</span>
        </li>
      ) : null}

      {!isProfileLinkHidden &&
      taraSubscriptionDetails &&
      taraSubscriptionDetails?.currentSubscriptionStatus === 'active' ? (
        <li
          onClick={() => {
            navigate('/settings/subscription');
          }}
        >
          <CustomSVGs svg={creditCardSVG} />
          <span>{t('Subscription')}</span>
        </li>
      ) : null}

      {/* {!isProfileLinkHidden ? (
        <li
          onClick={() => {
            navigate('/settings/general');
          }}
        >
          <CustomSVGs svg={userSVG} />
          <span>{t('EditProfile')}</span>
        </li>
      ) : null} */}

      {!isSettingsLinkHidden ? (
        <li
          onClick={() => {
            navigate('/settings');
          }}
        >
          <CustomSVGs svg={settingsPlusSVG} />
          <span>{t('Settings')}</span>
        </li>
      ) : null}

      {/* <li
        onClick={() => {
          dispatch(setAppThemeMode());
        }}
      >
        {appTheme ? <CustomSVGs svg={sunSVG} /> : <CustomSVGs svg={moonSVG} />}
        {!appTheme && <span>{t('DarkMode')}</span>}
        {appTheme && <span>{t('LightMode')}</span>}
      </li> */}
      <li
        onClick={() => {
          window.open('https://intercom.help/ad-up/en', '_blank');
        }}
      >
        <CustomSVGs svg={questionSVG} />
        <span>{t('Support')}</span>
      </li>
      <li onClick={logoutHandler}>
        <CustomSVGs svg={logoutSVG} />
        <span>{t('Logout')}</span>
      </li>
    </motion.ul>
  );
};

export default SidebarProfileTheme2;
